<template>
  <section id="contact" class="contact">
    <div class="container">
      <h2 class="section-title">联系我们</h2>
      <p class="section-lead">
        售前方案咨询与售后技术支持分线服务，欢迎留下需求，我们将尽快与您联系。
      </p>
      <div class="contact-content">
        <div class="contact-info">
          <div class="info-block">
            <h4>售前咨询</h4>
            <p>0527-88266855</p>
          </div>
          <div class="info-block">
            <h4>售后服务</h4>
            <p>0527-88266855-6</p>
          </div>
          <div class="info-block">
            <h4>企业邮箱</h4>
            <p>772919504@qq.com</p>
          </div>
          <div class="info-block">
            <h4>总部地址</h4>
            <p>江苏省宿迁市沭阳县苏奥产业园北区</p>
          </div>
        </div>
        
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  methods: {
    handleSubmit() {
      alert('感谢您的留言，我们会尽快与您联系！')
    }
  }
}
</script>

<style scoped>
.contact {
  padding: 100px 0;
  background: #f0f4f8;
}

.section-title {
  text-align: center;
  font-size: 42px;
  margin-bottom: 16px;
  color: #0c4a6e;
  font-weight: 700;
}

.section-lead {
  text-align: center;
  font-size: 16px;
  color: #64748b;
  max-width: 560px;
  margin: 0 auto 48px;
  line-height: 1.7;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  max-width: 1100px;
  margin: 0 auto;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 28px;
}

.info-block {
  background: #fff;
  padding: 20px 22px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.info-block h4 {
  font-size: 15px;
  margin: 0 0 8px;
  color: #0c4a6e;
  font-weight: 600;
}

.info-block p {
  font-size: 15px;
  color: #475569;
  margin: 0;
  line-height: 1.55;
}

.contact-form {
  background: #fff;
  padding: 36px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 32px rgba(12, 74, 110, 0.06);
}

.form-group {
  margin-bottom: 18px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #0284c7;
}

.submit-button {
  width: 100%;
  padding: 14px;
  background: #0284c7;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.submit-button:hover {
  background: #0369a1;
}

@media (max-width: 768px) {
  .contact-info { grid-template-columns: 1fr; }
}
</style>
